import axios from "axios";

export default function addLoyaltyPoint({
  point,
  product_uuids,
  instant_win_uuids,
}) {
  return new Promise((resolve, reject) => {
    axios
      .post("/campaignV2/customer/loyaltyPoint/create", {
        point,
        product_uuids,
        instant_win_uuids,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
